module.exports = __webpack_public_path__ + "static/media/Ruben.12a526b8.jpg";